<template>
<link v-if="isUmbraco" rel="stylesheet" href="/assets/index.css" />

  <div :class="containerStyles">
    <custom-image
      v-if="image"
      :image="image"
      classes="w-full object-cover aspect-[4/3]"
      loading="lazy"
    />
    <header4
      :text="fullName"
      :is-umbraco="isUmbraco"
      :theme="themeType"
      classes="mt-6 md:mt-8"
    />
    <paragraph
      v-if="jobPosition"
      :text="jobPosition"
      :is-umbraco="isUmbraco"
      :theme="themeType"
    />
    <paragraph
      v-if="country"
      :text="country"
      :is-umbraco="isUmbraco"
      :theme="themeType"
      classes="mb-3"
    />
    <a :href="'mailto:' + email" class="group" target="_blank">
      <paragraph
        v-if="email"
        classes="font-bold group-hover:text-orange"
        :text="email"
        :is-umbraco="isUmbraco"
        :theme="themeType"
      />
    </a>

    <a :href="'tel:' + phone" class="group">
      <paragraph
        v-if="phone"
        classes="font-bold group-hover:text-orange"
        :text="phone"
        :is-umbraco="isUmbraco"
        :theme="themeType"
      />
    </a>
    <a v-if="link" :href="link" class="group">
      <paragraph
        v-if="linkTitle"
        classes="font-bold group-hover:text-orange"
        :text="linkTitle"
        :is-umbraco="isUmbraco"
        :theme="themeType"
      />
    </a>
  </div>
</template>
<script lang="ts" setup>
import Header4 from "@components/Typography/Header4.ce.vue";
import Paragraph from "@components/Typography/Paragraph.ce.vue";
import CustomImage from "@atoms/Image/Img.vue";
import { IContactProps } from "@/types/components/IContactListProps";
import { toRefs, computed, onMounted } from "vue";

const props = defineProps<IContactProps>();
const {
  fullName,
  jobPosition,
  email,
  country,
  image,
  phone,
  link,
  linkTitle,
  isUmbraco,
  themeType,
  classes,
} = toRefs(props);

const containerStyles = computed(() => {
  return `flex flex-col ${classes?.value}`;
});
</script>
